const IdentifierType = Object.freeze({
  UNIT_NUMBER: "UNIT_NUMBER",
  FACILITY_ID: "FACILITY_ID",
  TEACHING_ID: "TEACHING_ID",
  HOUSEHOLD_ANCHOR_LEGACY_CMIS_ID: "HOUSEHOLD_ANCHOR_LEGACY_CMIS_ID",
  PROGRAM_ID: "PROGRAM_ID",
  CUSTOM_ID: "CUSTOM_ID"
});
export default IdentifierType;